/* tslint:disable */
import { MinMax } from './min-max';

/**
 */
export class ViewMinMaxProductMeshPacking {
    mmDim1?: MinMax;
    mmDim2?: MinMax;
    mmDim3?: MinMax;
    mmMass?: MinMax;
    mmTemp?: MinMax;
    mmThickness?: MinMax;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-min-max-product-mesh-packing.ts